/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WebApiModelsEnumerationTypesEmailTemplatePurpose = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;
export type WebApiModelsEnumerationTypesEmailTemplatePurpose = typeof WebApiModelsEnumerationTypesEmailTemplatePurpose[keyof typeof WebApiModelsEnumerationTypesEmailTemplatePurpose];


export function WebApiModelsEnumerationTypesEmailTemplatePurposeFromJSON(json: any): WebApiModelsEnumerationTypesEmailTemplatePurpose {
    return WebApiModelsEnumerationTypesEmailTemplatePurposeFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesEmailTemplatePurposeFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesEmailTemplatePurpose {
    return json as WebApiModelsEnumerationTypesEmailTemplatePurpose;
}

export function WebApiModelsEnumerationTypesEmailTemplatePurposeToJSON(value?: WebApiModelsEnumerationTypesEmailTemplatePurpose | null): any {
    return value as any;
}

